import * as _resx from '../../resx/resx';

export var appTitle = "Worksite Viewer";
export var virtualDirRoot = window.location.origin + "/";
export var configApi = virtualDirRoot + 'api/config';
export var serviceName = virtualDirRoot + 'breeze';
export var storeExpirationMs = (1000 * 60 * 60 * 24 * 30); //30 days
export var dayMs = (1000 * 60 * 60 * 24); //1 day
export var throttleMs = 200;
export var toastrTimeoutMs = 4000; //4 seconds
export var resx: typeof _resx = _resx;
export var skipFieldsForMessage = ["rights", "createdDate", "id", "createdByUserId", "modifiedDate", "modifiedByUserId", "relatedRecordId", "sortOrder"];

export var startUrl = '';

export var stateKeys = {
    metadataHash: appTitle + ':metadataHash',
    annotatedMetadataHash: appTitle + ':annotatedMetadataHash',
    lookupsHash: appTitle + ':lookupsHash',
    breezeMetadata: appTitle + ':breezeMetadata',
    lookups: appTitle + ':lookups',
    annotatedMetadata: appTitle + ':annotatedMetadata',
    savedRoute: appTitle + ':savedRoute'
}

export var hashes = {
    currentMetadataHash: '',
    currentAnnotatedMetadataHash: '',
    currentLookupsHash: ''
}
